const getTimezone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export { getTimezone };
